import { render, staticRenderFns } from "./InformeSISA.vue?vue&type=template&id=3854320e&"
import script from "./InformeSISA.vue?vue&type=script&lang=js&"
export * from "./InformeSISA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports